import { useAuthAxios } from '@/backend/utils'

const baseURL = process.env.NODE_ENV === 'development'
  ? '/api/v2/'
  : `${process.env.VUE_APP_BASE_URL}/api/v2/`

const http = useAuthAxios({ baseURL })

export async function enrichRoutesFile(file) {
  const formData = new FormData()
  formData.append('file', file)

  return http.post('ati/routes/enrich-file', formData, {
    responseType: 'blob',
  })
}
